import React, { useEffect, useState, useCallback } from 'react';
import { fetchSavedGrocery, addGroceryItem, fetchGrocery } from '../api';

export default function QuickAddPanel({ onItemAdded }) {
  const [saved, setSaved] = useState([]);
  const [active, setActive] = useState(new Set());

  const loadSaved = useCallback(async () => {
    const data = await fetchSavedGrocery();
    setSaved(data);
  }, []);

  const loadActive = useCallback(async () => {
    const items = await fetchGrocery();
    const names = new Set(
      items.filter(i => !i.checked).map(i => i.name.toLowerCase())
    );
    setActive(names);
  }, []);

  useEffect(() => {
    loadSaved();
    loadActive();
    const t = setInterval(loadActive, 30 * 1000);
    return () => clearInterval(t);
  }, [loadSaved, loadActive]);

  const handleTap = async (name) => {
    if (active.has(name.toLowerCase())) return;
    await addGroceryItem(name);
    setActive(prev => new Set([...prev, name.toLowerCase()]));
    if (onItemAdded) onItemAdded();
  };

  if (saved.length === 0) return null;

  return (
    <div style={styles.panel}>
      <div style={styles.header}>
        <span style={styles.label}>Quick Add</span>
        <span style={styles.dot} />
      </div>
      <div style={styles.chipGrid}>
        {saved.map(item => {
          const done = active.has(item.name.toLowerCase());
          return (
            <button
              key={item.id}
              style={{
                ...styles.chip,
                ...(done ? styles.chipDone : styles.chipReady),
              }}
              onClick={() => handleTap(item.name)}
              disabled={done}
            >
              {done ? '✓ ' : '+ '}{item.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  panel: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  label: {
    fontFamily: 'var(--font-mono)',
    fontSize: '0.65rem',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: 'var(--text-dimmer)',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: 'var(--accent)',
    boxShadow: '0 0 6px var(--accent)',
  },
  chipGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 7,
  },
  chip: {
    fontFamily: 'var(--font-mono)',
    fontSize: '0.75rem',
    borderRadius: 20,
    padding: '6px 13px',
    cursor: 'pointer',
    letterSpacing: '0.03em',
    transition: 'all 0.15s',
    border: 'none',
  },
  chipReady: {
    color: 'var(--accent)',
    background: 'rgba(232,201,122,0.1)',
    border: '1px solid rgba(232,201,122,0.35)',
  },
  chipDone: {
    color: 'var(--text-dimmer)',
    background: 'transparent',
    border: '1px solid var(--border)',
    cursor: 'default',
    opacity: 0.5,
  },
};
